import { type Proveedor, type ProveedorRequest, type ProveedorResponse, type ProveedorFiltered } from '../types/proveedor';
import { http } from '../../../../api/http';

export class ProveedorService {
  private static readonly ENDPOINTS = {
    LIST: '/proveedor/list',
    FILTERED_LIST: '/proveedor/filtered-list',
    CREATE: '/proveedor',
    GET_BY_ID: '/proveedor',
  };

  public static async getProveedores(): Promise<Proveedor[]> {
    try {
      const response = await http.get(this.ENDPOINTS.LIST);
      return response.data;
    } catch (error) {
      console.error('Error fetching proveedores:', error);
      throw error;
    }
  }

  public static async getFilteredProveedores(): Promise<ProveedorFiltered[]> {
    try {
      const response = await http.get(this.ENDPOINTS.FILTERED_LIST);
      return response.data;
    } catch (error) {
      console.error('Error fetching filtered proveedores:', error);
      throw error;
    }
  }

  public static async saveProveedor(proveedorRequest: ProveedorRequest): Promise<Proveedor> {
    try {
      const isUpdate = !!proveedorRequest.idPersona;

      console.log(`${isUpdate ? 'Updating' : 'Creating'} proveedor:`, {
        url: this.ENDPOINTS.CREATE,
        method: 'POST',
        isUpdate,
        data: proveedorRequest
      });

      const response = await http.post(this.ENDPOINTS.CREATE, proveedorRequest);

      console.log(`Proveedor ${isUpdate ? 'updated' : 'created'} successfully:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error ${proveedorRequest.idPersona ? 'updating' : 'creating'} proveedor:`, error);
      throw error;
    }
  }

  // Keep the old method name for backward compatibility
  public static async createProveedor(proveedorRequest: ProveedorRequest): Promise<Proveedor> {
    return this.saveProveedor(proveedorRequest);
  }

  public static async getProveedorById(idPersona: number): Promise<ProveedorResponse> {
    try {
      const response = await http.get(`${this.ENDPOINTS.GET_BY_ID}/${idPersona}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching proveedor by id:', error);
      throw error;
    }
  }
}